import request from "../utils/request";

export function queryH5ByCaseId(caseId) {
  return request({
    url: '/ele/case/queryH5ByCaseId',
    method: 'post',
    params: { caseId },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function queryChatRecordPage(data) {
  return request({
    url: '/ele/chatrecord/queryChatRecordPage',
    method: 'post',
    data,
  })
}

export function chatInitialization(caseId) {
  return request({
    url: '/ele/chatWindow/chatInitialization',
    method: 'get',
    params: { caseId },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export async function buryingPoint(data) {
  let response = null;
  try {
    response = await request('https://api.ipify.org?format=json');
  }catch (e) {}
  Object.assign(data, {
    source: 'mediate-h5',
    ip: response ? response.ip : ''
  });
  return request({
    url: '/ele/apiout/buryingPoint',
    method: 'post',
    data,
  })
}
export async function querySign(caseId) {
  return request({
    url: '/ele/apiout/querySign',
    method: 'post',
    data: {
      caseId
    }
  })
}
export async function checkSign(data) {
  return request({
    url: '/ele/apiout/checkSign',
    method: 'post',
    data,
  })
}
export async function queryPetition(data) {
  return request({
    url: '/ele/apiout/queryPetition',
    method: 'post',
    data: {
      orderId: data
    }
  })
}
export async function checkPetitionSign(data) {
  return request({
    url: '/ele/apiout/checkPetitionSign',
    method: 'post',
    data,
  })
}
